import { createComponent } from '@front/utils/alpine';
const Banner = createComponent(() => ({
    timer: null,
    way: 1,
    interval: 4000,
    launchSlider() {
        this.clearTimer();
        this.$refs.bannerContainer.style.top = '0px';
        const totalHeight = Array.from(this.$refs.bannerContainer.children).reduce((acc, child) => acc + child.offsetHeight, 0);
        const child = this.$refs.bannerContainer
            .firstElementChild;
        if (child) {
            this.timer = setInterval(() => this.setBannerPosition(child, totalHeight), this.interval);
        }
    },
    clearTimer() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    setBannerPosition(child, totalHeight) {
        const maxHeight = totalHeight - child.offsetHeight;
        let currentTop = parseFloat(this.$refs.bannerContainer.style.top);
        if (isNaN(currentTop))
            currentTop = 0;
        if (this.way == 1) {
            if (Math.abs(currentTop) < maxHeight) {
                this.$refs.bannerContainer.style.top =
                    currentTop - child.offsetHeight + 'px';
            }
            else {
                this.way = 0;
            }
        }
        else if (this.way == 0) {
            if (currentTop < 0) {
                this.$refs.bannerContainer.style.top =
                    currentTop + child.offsetHeight + 'px';
            }
            else {
                this.way = 1;
            }
        }
    },
    init() {
        this.launchSlider();
        window.addEventListener('resize', () => {
            this.launchSlider();
        });
    },
    destroy() {
        this.clearTimer();
        window.removeEventListener('resize', this.launchSlider.bind(this));
    },
}));
export { Banner };
